<template>
    <section
        v-if="content"
        class="c-integration-sch"
    >
        <div class="c-integration-sch__content">
            <div
                v-if="content.title"
                class="integration-content__title"
            >
                <h2>
                    {{ content.title }}
                </h2>
            </div>
            <ul
                v-if="content.albums"
                class="integration-content__list"
            >
                <li
                    v-for="item in content.albums"
                    :key="item.id"
                    class="list-item"
                >
                    <img
                        src="@/assets/images/tick.png"
                        alt=""
                        class="list-item__tick"
                    >
                    <div class="list-item__content">
                        <h3 class="list-item__title">
                            {{ item.title }}
                        </h3>
                        <p class="list-item__description">
                            {{ item.description }}
                        </p>
                    </div>
                </li>
            </ul>
            <div
                v-if="content.custom"
                class="integration-content__action"
            >
                <y-button
                    :tag="isLink(content.custom['button-link']) ? 'a' : 'router-link'"
                    :href="content.custom['button-link']"
                    :to="content.custom['button-link']"
                    :content="content.custom['button-title']"
                    color="primary"
                    size="medium"
                    flat
                    no-padding
                />
            </div>
        </div>
        <div
            v-if="content.image"
            class="c-integration-sch__image"
        >
            <img
                :src="imgSrc(content.image)"
                :alt="content.title"
                class="significance-img"
                :height="$mq === 'md' || $mq === 'lg' || $mq === 'xlg' ? 467 : 330"
                :width="$mq === 'md' || $mq === 'lg' || $mq === 'xlg' ? 467 : 330"
            >
        </div>
    </section>
</template>

<script >
    import { isLink } from '@/helpers/helpers';

    export default {
        name      : 'IntegrationSCH',
        components: {
        },

        props: {
            content: {
                type    : Object,
                required: true,
            },
        },
        /**
         *
         * @inheritDoc
         */
        methods: {
            isLink,
        },
    };

</script>

<style lang="scss" src="./index.scss"/>
